import React from 'react';
import { Bell, Search, User } from 'lucide-react';
import { motion } from 'framer-motion';
import { TabType } from '../App';

interface HeaderProps {
  activeTab: TabType;
}

const tabTitles: Record<TabType, string> = {
  dashboard: 'Your Impact',
  missions: 'Eco Missions',
  social: 'Community',
  rewards: 'Rewards',
  profile: 'Profile'
};

export default function Header({ activeTab }: HeaderProps) {
  return (
    <header className="safe-top glass-effect border-b border-gray-200/50 px-4 py-3">
      <div className="flex items-center justify-between">
        {/* Title */}
        <motion.h1
          key={activeTab}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="text-xl font-bold text-gray-900"
        >
          {tabTitles[activeTab]}
        </motion.h1>

        {/* Actions */}
        <div className="flex items-center space-x-3">
          {/* Search Button */}
          <button className="touch-target p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors">
            <Search className="h-5 w-5 text-gray-600" />
          </button>

          {/* Notifications */}
          <button className="touch-target p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors relative">
            <Bell className="h-5 w-5 text-gray-600" />
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
              <span className="text-xs font-bold text-white">3</span>
            </span>
          </button>

          {/* Profile */}
          <button className="touch-target">
            <img
              src="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop"
              alt="Profile"
              className="w-8 h-8 rounded-full border-2 border-emerald-200"
            />
          </button>
        </div>
      </div>

      {/* EcoCoins Display */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.1, duration: 0.2 }}
        className="mt-3 flex items-center justify-center"
      >
        <div className="bg-emerald-50 px-4 py-2 rounded-full border border-emerald-200">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
            <span className="text-sm font-semibold text-emerald-700">
              1,247 EcoCoins
            </span>
          </div>
        </div>
      </motion.div>
    </header>
  );
}